import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subscription, combineLatest} from 'rxjs';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {ListHealthData} from '../../../services/data/volatile-settings-data.service';
import { LocalisationService } from 'src/app/services/localisation.service';
import { Store } from '@ngrx/store';
import { AppSelectors } from 'src/app/state/app';

export interface HealthData {
  healthData$: Observable<ListHealthData[]>;
}

@Component({
  selector: 'app-data-health',
  templateUrl: './data-health.dialog.html',
  styleUrls: ['./data-health.dialog.scss'],
  standalone: false
})
export class DataHealthDialog implements OnInit, OnDestroy {
  error = false;
  dataLoaded = false;
  displayedColumns: string[] = ['application', 'jobName', 'status', 'startTime', 'endTime', 'duration'];
  dataSource = new MatTableDataSource<ListHealthData>([]);
  subscription!: Subscription;
  timezoneAbv: string;
  currentTime: Date = new Date();
  constructor(
    public dialogRef: MatDialogRef<DataHealthDialog>,
    private store: Store,
    public localisationService: LocalisationService,
    @Inject(MAT_DIALOG_DATA) public data: HealthData) {
    this.dialogRef.addPanelClass('settings-modal-dialog-panel');
  }


  ngOnInit(): void {
    this.subscription =combineLatest( this.data.healthData$, this.store.select(AppSelectors.getSettings)).subscribe(([hd, settings]) => {
      this.dataSource.data = hd;
      this.timezoneAbv = this.localisationService.getTimeZoneAbv(settings)
      this.dataLoaded = true;
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
